// /forge/application — Application phase page (pre-BOD pipeline).
//
// Wraps existing Recruitment analytics as the "Pipeline" tab. Remaining tabs
// are placeholders; PR C fills them with velocity/drop-off, historical
// throughput, and the coordinator workload views.
//
// Previously routed at /forge/recruitment — that URL now redirects here.

import PhaseTabs, { PlaceholderTab } from "../../components/shared/PhaseTabs";
import Recruitment from "./Recruitment";

export default function Application() {
  return (
    <PhaseTabs
      eyebrow="FORGE · Application"
      title="Application"
      subtitle="Pre-BOD pipeline — funnel, persona progression, and drop-off analysis."
      tabs={[
        {
          key: "pipeline",
          label: "Pipeline",
          content: <Recruitment />,
        },
        {
          key: "velocity",
          label: "Velocity & Drop-off",
          placeholder: true,
          content: (
            <PlaceholderTab hint="Avg days per stage, drop-off between stages, and flagged stalls. Pulls from sync/ml-applicant.ts forecasts." />
          ),
        },
        {
          key: "historical",
          label: "Historical Throughput",
          placeholder: true,
          content: (
            <PlaceholderTab hint="Applications per month over the last 24 months, YoY delta, and seasonal pattern from BOD minutes corpus." />
          ),
        },
        {
          key: "coordinator-workload",
          label: "Coordinator Workload",
          placeholder: true,
          content: (
            <PlaceholderTab hint="Per-coordinator backlog, disengaged applicants, and notes ledger. Gated to coordinator/admin roles when it lands." />
          ),
        },
      ]}
    />
  );
}
